import api from "./api";

/**
 * Serviço da apuração PLcom (Revisor SPED's → relatórios por XMLs).
 * O backend recebe os XMLs, o worker agrega os totais por semana e grava
 * o relatório no Elasticsearch (índice plcom_relatorios).
 */
const plcomService = {
  listar: () => api.get("/plcom/relatorios").then((r) => r.data.data || []),

  detalhar: (id) => api.get(`/plcom/relatorios/${id}`).then((r) => r.data.data),

  /**
   * Envia XMLs (.xml soltos ou um .zip) — criando relatório novo ou
   * adicionando uma semana a um relatório existente.
   * Retorna { relatorioId, ... } — o processamento é assíncrono (worker).
   */
  async uploadXmls({ files, competencia, relatorioId, semanaAlvo }) {
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    if (competencia) fd.append("competencia", competencia);
    if (semanaAlvo) fd.append("semanaAlvo", String(semanaAlvo));
    const url = relatorioId ? `/plcom/relatorios/${relatorioId}/xmls` : "/plcom/upload";
    const { data } = await api.post(url, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120000,
    });
    return data;
  },

  atualizar: (id, patch) => api.patch(`/plcom/relatorios/${id}`, patch).then((r) => r.data),

  excluir: (id) => api.delete(`/plcom/relatorios/${id}`).then((r) => r.data),

  /** Polling simples até o worker terminar (status != processando). */
  async aguardar(id, { tentativas = 40, intervalo = 3000 } = {}) {
    for (let i = 0; i < tentativas; i++) {
      const doc = await plcomService.detalhar(id);
      if (doc.status !== "processando") return doc;
      await new Promise((r) => setTimeout(r, intervalo));
    }
    return plcomService.detalhar(id);
  },
};

export default plcomService;
